import React, { Component } from 'react';

import { Collapse, CardBody, Card, CardHeader } from 'reactstrap';

class FAQQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: this.props.collapse ? this.props.collapse : false
    };
  }
  toggle = () => {
    this.setState({
      collapse: !this.state.collapse
    });
  };
  
  render() {
    let plus;
    const renderContent = (content) => {
      return { __html: content };
    }
    if (!this.state.collapse) {
      switch (true) {
        case (window.location.href.indexOf("/business/lb") > 0): {
          plus = <span className="eir-icon eir-icon--sm icon-plus-lb--primary faq-cross-icon float-right" />;
          break;
        }
        case (window.location.href.indexOf("/business/") > 0): {
          plus = <span className="eir-icon eir-icon--sm icon-plus-smb--primary faq-cross-icon float-right" />;
          break;
        }
        default: {
          plus = <span className="eir-icon eir-icon--sm icon-plus--primary faq-cross-icon float-right" />;
        }
      }
    } else {
      switch (true) {
        case (window.location.href.indexOf("/business/lb") > 0): {
          plus = <span className="eir-icon eir-icon--sm icon-plus-lb--primary faq-cross-icon float-right rotate" />;
          break;
        }
        case (window.location.href.indexOf("/business/") > 0): {
          plus = <span className="eir-icon eir-icon--sm icon-plus-smb--primary faq-cross-icon float-right rotate" />;
          break;
        }
        default: {
          plus = <span className="eir-icon eir-icon--sm icon-plus--primary faq-cross-icon float-right rotate" />;
        }
      }

    }
    return (
      <Card className="eir-faq-card">
        <CardHeader
          className="eir-faq-header"
          onClick={this.toggle}
          data-id={this.props.id}
        >
          {/* <h6 data-id={this.props.id} className="mb-0 eir-faq-header-text">
            {this.props.question}
            {plus}
          </h6> */}
          <div className={'mb-0 eir-faq-header-text '}  dangerouslySetInnerHTML={renderContent(this.props.question)} {...plus} />
        
        </CardHeader>
        <Collapse isOpen={this.state.collapse}>
          <CardBody className="eir-faq-body">
            {(typeof this.props.answer === 'string') &&
              <div dangerouslySetInnerHTML={{ __html: this.props.answer }} />}

            {(typeof this.props.answer != 'string') &&
              this.props.answer}
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

export default FAQQuestion;
